import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import { iamRevokeAllRefreshTokens } from '@crossnokaye/typescript-sdk/funcs/iamRevokeAllRefreshTokens';
import {
  RevokeAllRefreshTokensRequest,
  RevokeAllRefreshTokensResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { atlasClient } from '@/clients/atlas';

export type RevokeAllTokensOptions = Omit<
  UseMutationOptions<RevokeAllRefreshTokensResponse, Error, RevokeAllRefreshTokensRequest>,
  'mutationFn'
>;

export type RevokeAllTokensResult = UseMutationResult<
  RevokeAllRefreshTokensResponse,
  Error,
  RevokeAllRefreshTokensRequest
>;

export function useRevokeAllTokens(options?: RevokeAllTokensOptions): RevokeAllTokensResult {
  return useMutation<RevokeAllRefreshTokensResponse, Error, RevokeAllRefreshTokensRequest>({
    mutationFn: async (request: RevokeAllRefreshTokensRequest) =>
      atlasClient<RevokeAllRefreshTokensRequest, RevokeAllRefreshTokensResponse>({
        atlasFunc: iamRevokeAllRefreshTokens,
        request,
      }),
    ...options,
  });
}
